var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-shimer"},[_c('ShimmerLoader',{staticClass:"header-shimer__shimer",class:'header-shimer__shimer--size-' + _vm.size}),_c('ShimmerLoader',{staticClass:"header-shimer__shimer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }